import React, { RefObject, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { TextInput } from 'packages/common-frontend/components/InputsBETA/TextInput';

type CurrencyInputProps = {
  state?: number;
  updateState?: (value?: number) => void;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  textAlign?: 'left' | 'right';
  inputRef?: RefObject<HTMLInputElement>;
};

type CurrencyForm = {
  value: number | null;
};

export const CurrencyInput = ({
  state,
  updateState,
  isDisabled = false,
  isReadOnly = false,
  textAlign = 'right',
  inputRef,
}: CurrencyInputProps) => {
  const form = useForm<CurrencyForm>({
    defaultValues: { value: state ?? null },
    mode: 'onBlur',
  });

  const onBlur = () => {
    const { value } = form.getValues();
    if (value !== state) {
      updateState?.(value ?? undefined);
    }
  };

  useEffect(() => {
    const currentValue = form.getValues().value;
    const newValue = state ?? null;

    if (currentValue !== newValue) {
      form.setValue('value', newValue);
    }
  }, [state, form]);

  return (
    <FormProvider {...form}>
      <TextInput<CurrencyForm>
        name="value"
        mask="usd"
        isReadOnly={isReadOnly}
        isDisabled={isDisabled}
        ref={inputRef}
        required
        InputProps={{ textAlign, onBlur }}
      />
    </FormProvider>
  );
};
